import "./profilePhoto.scss"

interface IMage{
    imageUrl: string;
  }
  
  export default function ProfilePhoto({imageUrl}:IMage){
      return(
          <div className="image-wrapper">
            <img src={imageUrl} />
          </div>
      )
  }